import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import About from "@/sections/About";
import Services from "@/sections/Services";
import FamaLab from "@/sections/FamaLab";
import WhyChoose from "@/sections/WhyChoose";
import HowItWorks from "@/sections/HowItWorks";
import FAQ from "@/sections/FAQ";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function Landing() {
    useEffect(() => {
        const reduce = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        if (reduce) return;

        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        window.__lenis = lenis;

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            delete window.__lenis;
        };
    }, []);

    return (
        <>
            <Header />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Services />
                <FamaLab />
                <WhyChoose />
                <HowItWorks />
                <FAQ />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </>
    );
}
